import { useEffect, useRef } from 'react';
const usePreviousPath = (value: string) => {
	//TODO: get home path from brand config to make this work for all brands including fasttrack
	const homePath = '/';
	const ref = useRef(homePath);
	useEffect(() => {
		ref.current = value;
	}, [value]);
	return ref.current;
};
export default usePreviousPath;
